module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade in modal-auto",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Alterar Valor da Recarga Automática")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "bold-600 text-center no-margin"
  }, [_vm._v("Valor da Recarga")]), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-recharge text-right recharge-value-dropdown",
    attrs: {
      "options": _vm.rechargesData,
      "value": _vm.value
    },
    on: {
      "itemSelected": _vm.changeRecharge
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), (_vm.value == -1) ? _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': _vm.errors.has('valueTotal')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|recargaMinima:' + _vm.minValue),
      expression: "'required|recargaMinima:' + minValue"
    }],
    staticClass: "form-control text-right input-recharge",
    attrs: {
      "id": "valueTotal",
      "type": "text",
      "name": "valueTotal",
      "placeholder": "R$ 00,00",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.valueFormatted
    },
    on: {
      "input": function($event) {
        return _vm.setTotal($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block help-block-recharge with-errors"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first("valueTotal")) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "recharge-open-tax"
  }, [_vm._v("\n            Taxa de Recarga:\n            "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(_vm.tax)))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.alterRechargeUnit()
      }
    }
  }, [_vm._v("\n          Confimar\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-53fdf3fd!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/contract/modal-automatic-value.vue
// module id = 2129
// module chunks = 1